import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {BackButton, Button, Container, Input, Text} from '../../components/@FreeModel';
import Header from '../../components/general/Header/Header';
import {useDispatch, useSelector} from "react-redux";
import {selectApplication} from "../../db/selectors";
import {gql, queryApplication} from "../../db/model";

interface ITaxInfoAddress {
  path: 'individual' | 'business';
}

const TaxInfoAddress = ({path}: ITaxInfoAddress): React.ReactElement => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {applicationID} = useParams()
  const application = useSelector(selectApplication)
  const [street1, setStreet1] = useState(application.address?.street1 ?? '')
  const [street2, setStreet2] = useState(application.address?.street2 ?? '')
  const [city, setCity] = useState(application.address?.city ?? '')
  const [state, setState] = useState(application.address?.state ?? '')
  const [postalCode, setPostalCode] = useState(application.address?.postalCode ?? '')

  useEffect(() => {
    // @ts-ignore
    dispatch(gql({
      query: queryApplication,
      variables: {id: applicationID},
      onSuccess: (data) => {
        setStreet1(data.application?.address?.street1 ?? '')
        setStreet2(data.application?.address?.street2 ?? '')
        setCity(data.application?.address?.city ?? '')
        setState(data.application?.address?.state ?? '')
        setPostalCode(data.application?.address?.postalCode ?? '')
      }
    }))
  }, [dispatch, applicationID]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (path === 'business') {
      navigate(`/contractors/${applicationID}/tax-info/business/ein`)
    } else {
      navigate(`/contractors/${applicationID}/tax-info/individual/social-security`)
    }
  };

  return (
    <Container>
      <Header title="Add Tax Info"/>
      <BackButton to={path === 'business' ? `/contractors/${applicationID}/tax-info/business` : `/contractors/${applicationID}/tax-info/individual`}/>

      <br/>
      <br/>

      <form onSubmit={handleSubmit}>
        <Text weight="semibold">Review the following information to verify that it is correct:</Text>

        <br/>

        <Input
          label="Address line 1"
          id="address-1"
          type="text"
          readOnly={true}
          value={street1}
        />
        <Input
          label="Address line 2"
          id="address-2"
          type="text"
          readOnly={true}
          value={street2}
        />
        <Input
          label="City"
          id="city"
          type="text"
          readOnly={true}
          value={city}
        />
        <Input
          label="State/Region"
          id="state-region"
          type="text"
          readOnly={true}
          value={state}
        />
        <Input
          label="Postal code"
          id="postal-code"
          type="text"
          readOnly={true}
          value={postalCode}
        />

        <br/>
        <br/>
        <br/>

        <Button>Continue</Button>
      </form>
    </Container>
  );
};

export default TaxInfoAddress;
